import { format, formatDistanceStrict, parseISO } from 'date-fns';

interface ReviewDetailsTask {
  assignments: ReadonlyArray<{ reviewRequestedAt: string | null }>;
  completedAt: string | null;
  round: number;
  startedAt: string | null;
}

export interface TaskReviewDetailValues {
  /** When review was last asked for, or when the task started if nobody has been asked yet. */
  requested: string | null;
  round: string;
  /** How long the task has been open, up to when it was completed. */
  runtime: string | null;
}

/** The values in the task page's Review details card. */
export function getTaskReviewDetailValues(
  task: ReviewDetailsTask,
  now: Date = new Date()
): TaskReviewDetailValues {
  const latestRequest = task.assignments
    .flatMap(assignment => (assignment.reviewRequestedAt ? [assignment.reviewRequestedAt] : []))
    .sort()
    .at(-1);
  const requestedAt = latestRequest ?? task.startedAt;
  const end = task.completedAt ? parseISO(task.completedAt) : now;

  return {
    requested: requestedAt ? format(parseISO(requestedAt), 'MMM d, yyyy') : null,
    round: String(task.round),
    runtime: task.startedAt ? formatDistanceStrict(parseISO(task.startedAt), end) : null,
  };
}

/** "Requested by YourCo · 2 documents", the subtitle an external reads under the title. */
export function getExternalTaskSubtitle(options: {
  documentCount: number;
  ownerName: string | null;
}): string {
  const { documentCount, ownerName } = options;
  const documents = `${documentCount} ${documentCount === 1 ? 'document' : 'documents'}`;
  return ownerName ? `Requested by ${ownerName} · ${documents}` : documents;
}
